/**
 * Synchronizes the value of a single input field to all other related fields.
 * @param inputFields - A NodeList of all input fields that should share the same value.
 * @param ev - The event that triggered the synchronization.
 */
const syncFieldValues = (inputFields: NodeListOf<HTMLInputElement>, ev: Event): void => {
    const inputTarget = ev.target as HTMLInputElement;
    const newValue = inputTarget.value;

    // Update all other fields with the same value
    inputFields.forEach(otherField => {
        if (otherField !== inputTarget) {
            otherField.value = newValue;
        }
    });
};

/**
 * Synchronizes the values of multiple input fields in a form.
 * @param formSelector - The selector of the form (e.g. '.edit-profile-form').
 * @param inputSelector - The selector of the input fields to be synchronized (e.g. '.js-form-control-birthday').
 * @param events - The events that trigger the synchronization.
 */
const syncSameFieldsInForm = (formSelector: string, inputSelector: string, events: string[] = ['keydown', 'paste']): void => {
    const form = document.querySelector<HTMLFormElement>(formSelector);
    if (!form) return;

    const inputFields = form.querySelectorAll<HTMLInputElement>(inputSelector);
    if (inputFields.length < 2) return;

    // Add event listeners to all fields
    inputFields.forEach(field => {
        events.forEach(event => field.addEventListener(event, ev => syncFieldValues(inputFields, ev)));
    });
};

const init = (): void => {
    syncSameFieldsInForm('.edit-profile-form', '.js-form-control-birthday');
    // Hidden date fields are updated by inputBirthdayMask.ts, which dispatches 'birthday:update'
    syncSameFieldsInForm('.edit-profile-form', '.js-form-control-birthday-hidden', ['birthday:update']);
};

export { init };
